export const getAggregateError = ( error: unknown, message: string, ): AggregateError => {

	if(error instanceof AggregateError) {
		error.errors.push(new Error(message));
		return error;
	}

	return (
		error instanceof Error ? new AggregateError([ error, new Error(message), ]) :
		typeof error === "string" && error.length > 0 ? new AggregateError([ new Error(error), new Error(message), ]) :
		new AggregateError([ new Error(`NON ERROR INSTANCE: ${String(error)}`), new Error(message), ])
	);
}
